@if (selectedRequest()) {
    <div>
        <div class="mb-3 mt-1 mt-md-2 mb-md-4">
            <app-timeline
                [steps]="timelineSteps()"
                [currentStep]="currentStep()"
                [allowAllSteps]="true"
                (stepChange)="currentStep.set($event)">
            </app-timeline>
        </div>

        <div class="panel mb-4">
            <div class="step-header d-flex align-items-center justify-content-between gap-3">
                <div class="d-flex align-items-center gap-3 min-w-0">
                    <h5 class="mb-0 text-dark fw-bold text-nowrap">
                        @switch (currentStepObj()?.title) {
                            @case ('Socio') {
                                <i class="fas fa-user me-2 text-primary"></i>Datos del Socio
                            }
                            @case ('Beneficio') {
                                <i class="fas fa-gift me-2 text-primary"></i>Beneficio
                            }
                            @case ('Aprobación') {
                                <i class="fas fa-gavel me-2 text-primary"></i>Aprobación de la Solicitud
                            }
                        }
                    </h5>
                    <app-flow-badge
                        display="badge"
                        [processSlug]="selectedRequest()?.processSlug"
                        [statusSlug]="selectedRequest()?.statusSlug">
                    </app-flow-badge>
                </div>
                @if (requestAmount() != null) {
                    <div class="text-end flex-shrink-0">
                        <div class="fs-4 fw-bold text-primary mb-0 lh-1">
                            {{ requestAmount() | currency:'CLP':'$':'1.0-0' }}
                        </div>
                        <span class="badge bg-light text-dark border mt-1">{{ benefitTypeLabel() }}</span>
                    </div>
                }
            </div>

            @if (currentStepObj()?.title === 'Socio') {
                <div class="step-body">
                    <app-party-form [partyForm]="partyForm" [mode]="formMode.VIEW"></app-party-form>
                    @if (vehicle(); as v) {
                        <div class="border rounded p-3 mt-4">
                            <div class="small text-uppercase fw-bold text-muted mb-2">
                                <i class="fas fa-car me-1"></i>Vehículo
                            </div>
                            <div class="row g-3">
                                <div class="col-md-4">
                                    <div class="small text-muted">Patente</div>
                                    <div class="fw-semibold">{{ v.plate || '—' }}</div>
                                </div>
                                <div class="col-md-4">
                                    <div class="small text-muted">Vehículo</div>
                                    <div class="fw-semibold">{{ vehicleLabel() }}</div>
                                </div>
                                <div class="col-md-4">
                                    <div class="small text-muted">Valor comercial</div>
                                    <div class="fw-semibold">
                                        @if (v.commercialValue || v.value) {
                                            {{ (v.commercialValue || v.value) | currency:'CLP':'$':'1.0-0' }}
                                        } @else {
                                            —
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }

            @if (currentStepObj()?.title === 'Beneficio') {
                <div class="step-body">
                    @if (benefit(); as b) {
                        <div class="row g-3 mb-3">
                            <div class="col-md-6">
                                <div class="small text-muted text-uppercase fw-bold">Tipo</div>
                                <div class="fw-semibold">{{ benefitTypeLabel() }}</div>
                            </div>
                            <div class="col-md-6">
                                <div class="small text-muted text-uppercase fw-bold">Fecha</div>
                                <div class="fw-semibold">{{ b.date | date:'dd/MM/yyyy' }}</div>
                            </div>
                        </div>
                        @if (b.capAmount != null) {
                            <div class="alert py-2 px-3 small mb-3"
                                [class.alert-success]="!b.overCap"
                                [class.alert-warning]="b.overCap">
                                <div>
                                    Tope vigente
                                    @if (b.capPercent != null) {
                                        ({{ b.capPercent }}% FMR)
                                    }
                                    : <strong>{{ b.capAmount | currency:'CLP':'$':'1.0-0' }}</strong>
                                </div>
                                @if (b.overCap) {
                                    <div class="mt-1">
                                        El monto supera el tope del reglamento. El rol autorizado puede aprobar la excepción.
                                    </div>
                                } @else {
                                    <div class="mt-1">El monto está dentro del tope.</div>
                                }
                            </div>
                        } @else {
                            <div class="alert alert-light border py-2 px-3 small mb-3">
                                Este tipo no tiene tope porcentual sobre FMR (reembolso contra boleta).
                            </div>
                        }
                    } @else {
                        <div class="alert alert-warning small mb-3">
                            No se encontró el beneficio asociado a esta solicitud.
                        </div>
                    }

                    <div class="mt-4">
                        <div class="small text-uppercase fw-bold text-muted mb-2">Documentos</div>
                        <app-document-approval
                            [referenceData]="selectedRequest()"
                            [canApprove]="canApprove()"
                            [canFinalApprove]="canApprove()"
                            (onReviewCompleted)="onReviewCompleted()">
                        </app-document-approval>
                    </div>
                </div>
            }

            @if (currentStepObj()?.title === 'Aprobación') {
                <div class="step-body">
                    <app-flow-steps [request]="selectedRequest()"></app-flow-steps>

                    @if (canRegisterPayment()) {
                        <div class="mt-3 text-center">
                            <button type="button" class="btn btn-outline-primary btn-sm px-4"
                                (click)="openPayModal()"
                                [disabled]="isProcessingApproval()">
                                <i class="fas fa-money-check-alt me-1"></i>Registrar / adjuntar pago
                            </button>
                        </div>
                    }

                    @if (canApprove()) {
                        <div class="d-flex flex-column align-items-center pt-4 mt-3 border-top">
                            <div class="d-flex gap-3 justify-content-center flex-wrap">
                                <button class="btn btn-success btn-lg px-5"
                                    (click)="approveRequest()"
                                    [disabled]="!canConfirmApprove()">
                                    <i class="fas fa-check-circle me-2"></i>
                                    {{ approveActionLabel() }}
                                </button>
                                <button class="btn btn-outline-danger btn-lg px-4"
                                    (click)="rejectRequest()"
                                    [disabled]="isProcessingApproval()">
                                    <i class="fas fa-times me-2"></i>Rechazar
                                </button>
                            </div>
                        </div>
                    }
                </div>
            }

            <div class="step-footer">
                <button class="btn btn-outline-secondary btn-sm px-3" (click)="prevStep()" [disabled]="currentStep() === 1">
                    <i class="fas fa-arrow-left me-2"></i> Anterior
                </button>
                <button class="btn btn-primary btn-sm px-3" (click)="nextStep()" [disabled]="currentStep() === timelineSteps().length">
                    Siguiente <i class="fas fa-arrow-right ms-2"></i>
                </button>
            </div>
        </div>
    </div>
}

<app-step-approval-modal
    [request]="selectedRequest()"
    [isProcessing]="isProcessingApproval()"
    (confirmed)="onStepApprovalConfirmed($event)">
</app-step-approval-modal>
